import React from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {SelectableOptionsContainer} from './SelectableOptionsContainer';
import Select from 'react-select';
import {AutoEnrichSchedule} from '../../../shared/enrichment';
import _ from 'lodash';

const AutoEnrichScheduleOptions = [
  {label: 'Every month', value: 'oneMonth'},
  {label: 'Every 3 months', value: 'threeMonths'},
  {label: 'Every 6 months', value: 'sixMonths'},
  {label: 'Every year', value: 'oneYear'},
] as const;

const AutoEnrichNewAccountsOption = ({
  autoEnrichNewAccounts,
  setAutoEnrichNewAccounts,
}: {
  autoEnrichNewAccounts: boolean | undefined;
  setAutoEnrichNewAccounts: (autoEnrichNewAccounts: boolean) => void;
}) => {
  return (
    <SelectableOptionsContainer
      componentType="checkbox"
      title="Automatically run on new accounts"
      isSelected={autoEnrichNewAccounts}
      onClick={() => setAutoEnrichNewAccounts(!autoEnrichNewAccounts)}
    />
  );
};

const AutoEnrichScheduleOption = ({
  autoEnrichSchedule,
  setAutoEnrichSchedule,
}: {
  autoEnrichSchedule: AutoEnrichSchedule | undefined;
  setAutoEnrichSchedule: (
    autoEnrichSchedule: AutoEnrichSchedule | undefined
  ) => void;
}) => {
  const isSelected = !!autoEnrichSchedule?.schedule;

  return (
    <SelectableOptionsContainer
      componentType="checkbox"
      title="Auto-refresh on a schedule"
      isSelected={isSelected}
      onClick={() => {
        setAutoEnrichSchedule({
          cutoffDate: autoEnrichSchedule?.cutoffDate,
          ...(!isSelected && {schedule: 'oneMonth'}),
        });
      }}
    >
      {isSelected && (
        <Box onClick={(e) => e.stopPropagation()}>
          <Select
            isMulti={false}
            menuPlacement="auto"
            options={AutoEnrichScheduleOptions}
            value={AutoEnrichScheduleOptions.find((option) =>
              _.isEqual(option.value, autoEnrichSchedule?.schedule)
            )}
            onChange={(option) => {
              if (!option) {
                return;
              }

              setAutoEnrichSchedule({
                cutoffDate: autoEnrichSchedule?.cutoffDate,
                schedule: option.value,
              });
            }}
          />
        </Box>
      )}
    </SelectableOptionsContainer>
  );
};

export const AutoRefreshOptions = ({
  autoEnrichNewAccounts,
  setAutoEnrichNewAccounts,
  autoEnrichSchedule,
  setAutoEnrichSchedule,
}: {
  autoEnrichNewAccounts: boolean | undefined;
  setAutoEnrichNewAccounts: (autoEnrichNewAccounts: boolean) => void;
  autoEnrichSchedule: AutoEnrichSchedule | undefined;
  setAutoEnrichSchedule: (
    autoEnrichSchedule: AutoEnrichSchedule | undefined
  ) => void;
}) => {
  return (
    <Flex direction="column" gap="4">
      <AutoEnrichNewAccountsOption
        autoEnrichNewAccounts={autoEnrichNewAccounts}
        setAutoEnrichNewAccounts={setAutoEnrichNewAccounts}
      />
      <AutoEnrichScheduleOption
        autoEnrichSchedule={autoEnrichSchedule}
        setAutoEnrichSchedule={setAutoEnrichSchedule}
      />
    </Flex>
  );
};
